import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_179142b8__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__18f_identity_i18n_6b4e2544__ from "@18f/identity-i18n";
import * as __WEBPACK_EXTERNAL_MODULE_react_dom_7dac9eee__ from "react-dom";
import * as __WEBPACK_EXTERNAL_MODULE_focus_trap_4348fbe4__ from "focus-trap";
/******/ // The require scope
/******/ var __webpack_require__ = {};
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bZ": () => (/* reexport */ alert_0),
  "yG": () => (/* reexport */ block_link),
  "zx": () => (/* reexport */ button_0),
  "IT": () => (/* reexport */ full_screen),
  "JO": () => (/* reexport */ icon_0),
  "Zd": () => (/* reexport */ icon_list),
  "$Z": () => (/* reexport */ icon_list_content),
  "Tw": () => (/* reexport */ icon_list_icon),
  "Mp": () => (/* reexport */ icon_list_item),
  "$f": () => (/* reexport */ icon_list_title),
  "rU": () => (/* reexport */ link_0),
  "WA": () => (/* reexport */ page_footer),
  "CD": () => (/* reexport */ page_heading),
  "cQ": () => (/* reexport */ process_list),
  "z8": () => (/* reexport */ process_list_heading),
  "qE": () => (/* reexport */ process_list_item),
  "R3": () => (/* reexport */ scroll_into_view),
  "lq": () => (/* reexport */ select_input),
  "mZ": () => (/* reexport */ spinner_dots),
  "oj": () => (/* reexport */ status_page),
  "Vp": () => (/* reexport */ tag),
  "oi": () => (/* reexport */ text_input),
  "HD": () => (/* reexport */ troubleshooting_options)
});

;// CONCATENATED MODULE: external "react"
var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const external_react_namespaceObject = x({ ["createContext"]: () => __WEBPACK_EXTERNAL_MODULE_react__.createContext, ["createElement"]: () => __WEBPACK_EXTERNAL_MODULE_react__.createElement, ["forwardRef"]: () => __WEBPACK_EXTERNAL_MODULE_react__.forwardRef, ["useCallback"]: () => __WEBPACK_EXTERNAL_MODULE_react__.useCallback, ["useContext"]: () => __WEBPACK_EXTERNAL_MODULE_react__.useContext, ["useEffect"]: () => __WEBPACK_EXTERNAL_MODULE_react__.useEffect, ["useImperativeHandle"]: () => __WEBPACK_EXTERNAL_MODULE_react__.useImperativeHandle, ["useMemo"]: () => __WEBPACK_EXTERNAL_MODULE_react__.useMemo, ["useRef"]: () => __WEBPACK_EXTERNAL_MODULE_react__.useRef, ["useState"]: () => __WEBPACK_EXTERNAL_MODULE_react__.useState });
;// CONCATENATED MODULE: external "react/jsx-runtime"
var jsx_runtime_x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var jsx_runtime_y = x => () => x
const jsx_runtime_namespaceObject = jsx_runtime_x({ ["Fragment"]: () => __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_179142b8__.Fragment, ["jsx"]: () => __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_179142b8__.jsx, ["jsxs"]: () => __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_179142b8__.jsxs });
;// CONCATENATED MODULE: ./alert.tsx


function Alert(_ref, ref) {
  let {
    type = 'other',
    className,
    isFocusable,
    children,
    textTag = 'p'
  } = _ref;
  const classes = [`usa-alert usa-alert--${type}`, className].filter(Boolean).join(' ');
  const role = type === 'error' ? 'alert' : 'status';
  const inner = /*#__PURE__*/(0,external_react_namespaceObject.createElement)(textTag, {
    className: 'usa-alert__text'
  }, children);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    ref: ref,
    className: classes,
    role: role,
    tabIndex: isFocusable ? -1 : undefined,
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
      className: "usa-alert__body",
      children: inner
    })
  });
}
/* harmony default export */ const alert_0 = (/*#__PURE__*/(0,external_react_namespaceObject.forwardRef)(Alert));
;// CONCATENATED MODULE: external "@18f/identity-i18n"
var identity_i18n_x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var identity_i18n_y = x => () => x
const identity_i18n_namespaceObject = identity_i18n_x({ ["i18n"]: () => __WEBPACK_EXTERNAL_MODULE__18f_identity_i18n_6b4e2544__.i18n, ["t"]: () => __WEBPACK_EXTERNAL_MODULE__18f_identity_i18n_6b4e2544__.t });
;// CONCATENATED MODULE: ./link.tsx



function isExternalURL(url) {
  let currentURL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
  try {
    return new URL(url).hostname !== new URL(currentURL).hostname;
  } catch {
    return false;
  }
}
function Link(_ref) {
  let {
    href,
    isExternal = isExternalURL(href),
    isNewTab = isExternal,
    className,
    children,
    ...anchorProps
  } = _ref;
  const classes = ['usa-link', className, isExternal && 'usa-link--external'].filter(Boolean).join(' ');
  let newTabProps;
  if (isNewTab) {
    newTabProps = {
      target: '_blank',
      rel: 'noreferrer'
    };
  }
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("a", {
    href: href,
    ...newTabProps,
    ...anchorProps,
    className: classes,
    children: [children, isNewTab && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("span", {
      className: "usa-sr-only",
      children: (0,identity_i18n_namespaceObject.t)('links.new_tab')
    })]
  });
}
/* harmony default export */ const link_0 = (Link);
;// CONCATENATED MODULE: ./block-link-arrow.tsx

function BlockLinkArrow() {
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.2 8.91",
    focusable: "false",
    "aria-hidden": "true",
    className: "block-link__arrow",
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      d: "M5.11 4.66L1 8.82a.36.36 0 01-.21.09.31.31 0 01-.2-.09l-.5-.45a.29.29 0 01-.09-.2A.36.36 0 01.09 8L3.6 4.45.09 1A.36.36 0 010 .74a.31.31 0 01.09-.2L.54.09A.31.31 0 01.74 0 .36.36 0 011 .09l4.11 4.16a.31.31 0 01.09.2.31.31 0 01-.09.21z",
      fill: "currentColor"
    })
  });
}
/* harmony default export */ const block_link_arrow = (BlockLinkArrow);
;// CONCATENATED MODULE: ./block-link.tsx




function BlockLink(_ref) {
  let {
    children,
    className,
    ...linkProps
  } = _ref;
  const classes = ['block-link', className].filter(Boolean).join(' ');
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(link_0, {
    ...linkProps,
    className: classes,
    children: [children, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(block_link_arrow, {})]
  });
}
/* harmony default export */ const block_link = (BlockLink);
;// CONCATENATED MODULE: ../assets/index.ts
function getAssetPath(path) {
  if (!getAssetPath.cache) {
    try {
      const script = document.querySelector('[data-asset-map]');
      getAssetPath.cache = JSON.parse(script.textContent);
    } catch {
      getAssetPath.cache = {};
    }
  }
  return getAssetPath.cache[path] || path;
}
getAssetPath.cache = undefined;
;// CONCATENATED MODULE: ./icon.tsx


const SPRITE_URL = getAssetPath('sprite.svg');
function Icon(_ref) {
  let {
    icon,
    className
  } = _ref;
  const classes = ['usa-icon', className].filter(Boolean).join(' ');
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("svg", {
    "aria-hidden": "true",
    focusable: false,
    role: "img",
    className: classes,
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("use", {
      href: [SPRITE_URL, icon].join('#')
    })
  });
}
/* harmony default export */ const icon_0 = (Icon);
;// CONCATENATED MODULE: ./button.tsx



function Button(_ref) {
  let {
    href,
    type = href ? undefined : 'button',
    children,
    isBig,
    isFlexibleWidth,
    isWide,
    isOutline,
    isDisabled,
    isUnstyled,
    icon,
    className,
    ...htmlAttributes
  } = _ref;
  const classes = ['usa-button', isBig && 'usa-button--big', isFlexibleWidth && 'usa-button--flexible-width', isWide && 'usa-button--wide', isOutline && 'usa-button--outline', isUnstyled && 'usa-button--unstyled', className].filter(Boolean).join(' ');
  const tagName = href ? 'a' : 'button';
  return /*#__PURE__*/(0,external_react_namespaceObject.createElement)(tagName, {
    type,
    href,
    disabled: isDisabled,
    className: classes,
    ...htmlAttributes
  }, icon && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(icon_0, {
    icon: icon
  }), children);
}
/* harmony default export */ const button_0 = (Button);
;// CONCATENATED MODULE: external "react-dom"
var external_react_dom_x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var external_react_dom_y = x => () => x
const external_react_dom_namespaceObject = external_react_dom_x({ ["createPortal"]: () => __WEBPACK_EXTERNAL_MODULE_react_dom_7dac9eee__.createPortal });
;// CONCATENATED MODULE: ../react-i18n/format-html.ts

/**
 * Given an HTML string and an object of tag names to React component, returns a new React node
 * where the mapped tag names are replaced by the resulting element of the rendered component.
 *
 * Note that this is a very simplistic interpolation of HTML. It only supports self-closing and
 * well-balanced, non-nested tag names, where there are no attributes or excess whitespace within
 * the tag names. The tag name cannot contain regular expression special characters.
 *
 * While the subject markup itself cannot contain attributes, the return value of the component can
 * be any valid React element, with or without additional attributes.
 *
 * @example
 * ```
 * formatHTML('Hello <lg-sparkles>world</lg-sparkles>!', {
 *   'lg-sparkles': ({children}) => <span className="lg-sparkles">{children}</span>
 * });
 * ```
 *
 * @param html HTML to format.
 * @param handlers Mapping of tag names to tag name or component.
 */
function format_html_formatHTML(html, handlers) {
  const pattern = new RegExp(`</?(?:${Object.keys(handlers).join('|')})(?: .*?)?/?>`, 'g');
  const matches = html.match(pattern);
  if (!matches) {
    return html;
  }
  const parts = html.split(pattern);

  // Count spliced insertions to use as an offset when replacing parts, since the subsequent loop's
  // iterator is based on matches and the original parts array.
  let spliceCount = 0;
  for (let i = 0; i < matches.length; i++) {
    const match = matches[i];
    const end = match.search(/ |\/?>/);
    const tag = matches[i].slice(1, end);
    const key = `part${i}`;
    const isSelfClosing = match.endsWith('/>');
    if (isSelfClosing) {
      const replacement = /*#__PURE__*/(0,external_react_namespaceObject.createElement)(handlers[tag], {
        key
      });
      parts.splice(i + spliceCount + 1, 0, replacement);
      spliceCount++;
    } else {
      const part = parts[i + spliceCount + 1];
      const replacement = /*#__PURE__*/(0,external_react_namespaceObject.createElement)(handlers[tag], {
        key
      }, part);
      parts[i + spliceCount + 1] = replacement;
      i++; // Increment to skip the closing tag
    }
  }

  return parts.filter(Boolean);
}
/* harmony default export */ const format_html = (format_html_formatHTML);
;// CONCATENATED MODULE: ../react-i18n/html_text_with_strong_no_wrap.tsx



function HtmlTextWithStrongNoWrap(_ref) {
  let {
    text
  } = _ref;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: formatHTML(text, {
      strong: _ref2 => {
        let {
          children
        } = _ref2;
        return /*#__PURE__*/_jsx("strong", {
          className: "text-no-wrap",
          children: children
        });
      }
    })
  });
}
/* harmony default export */ const html_text_with_strong_no_wrap = ((/* unused pure expression or super */ null && (HtmlTextWithStrongNoWrap)));
;// CONCATENATED MODULE: ../react-i18n/i18n-context.ts


const I18nContext = /*#__PURE__*/(0,external_react_namespaceObject.createContext)(identity_i18n_namespaceObject.i18n);
I18nContext.displayName = 'I18nContext';
/* harmony default export */ const i18n_context = (I18nContext);
;// CONCATENATED MODULE: ../react-i18n/use-i18n.ts



function useI18n() {
  const {
    t
  } = (0,external_react_namespaceObject.useContext)(i18n_context);
  return {
    t,
    formatHTML: format_html
  };
}
/* harmony default export */ const use_i18n = (useI18n);
;// CONCATENATED MODULE: ../react-i18n/index.ts




;// CONCATENATED MODULE: ../react-hooks/use-did-update-effect.ts


/**
 * A hook behaving the same as useEffect in invoking the given callback when dependencies change,
 * but does not call the callback during initial mount or when unmounting. It can be considered as
 * similar to ReactComponent#componentDidUpdate.
 */
const useDidUpdateEffect = (callback, deps) => {
  const isMounting = useRef(true);
  useEffect(() => {
    if (isMounting.current) {
      isMounting.current = false;
    } else {
      callback();
    }
  }, deps);
};
/* harmony default export */ const use_did_update_effect = ((/* unused pure expression or super */ null && (useDidUpdateEffect)));
;// CONCATENATED MODULE: ../react-hooks/use-if-still-mounted.ts


/**
 * Hook which returns a higher-order function to compose another function to be
 * executed only if the component is mounted.
 *
 * Note that this can be useful in creating safe callbacks for promise results,
 * but since dangling references to components can cause memory leaks, it's
 * preferred to cancel a subscription immediately on unmount whenever possible.
 *
 * @see https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
 */
function useIfStillMounted() {
  const isMounted = (0,external_react_namespaceObject.useRef)(false);
  (0,external_react_namespaceObject.useEffect)(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  });
  const ifStillMounted = fn => function () {
    if (isMounted.current) {
      fn(...arguments);
    }
  };
  return ifStillMounted;
}
/* harmony default export */ const use_if_still_mounted = (useIfStillMounted);
;// CONCATENATED MODULE: ../react-hooks/use-immutable-callback.ts


/**
 * React hook which returns a callback function which itself maintains a constant reference, but
 * which invokes the latest reference of the given function.
 *
 * @see https://reactjs.org/docs/hooks-faq.html#how-to-read-an-often-changing-value-from-usecallback
 *
 * @param fn
 * @param dependencies Callback dependencies
 */
function useImmutableCallback(fn) {
  let dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const ref = (0,external_react_namespaceObject.useRef)(() => {});
  (0,external_react_namespaceObject.useEffect)(() => {
    ref.current = fn;
  }, [fn, ...dependencies]);
  return (0,external_react_namespaceObject.useCallback)(function () {
    return ref.current(...arguments);
  }, [ref]);
}
/* harmony default export */ const use_immutable_callback = (useImmutableCallback);
;// CONCATENATED MODULE: ../react-hooks/use-instance-id.ts

let instances = 0;

/**
 * Returns a string value guaranteed to be unique to all element instances in the application. This
 * can be used in generic unique IDs when needed in, for example, form input label association.
 */
function useInstanceId() {
  return (0,external_react_namespaceObject.useMemo)(() => {
    instances += 1;
    return String(instances);
  }, []);
}
/* harmony default export */ const use_instance_id = (useInstanceId);
;// CONCATENATED MODULE: ../react-hooks/use-object-memo.ts


/**
 * React hook which creates a memoized object whose reference changes when values of the object
 * changes.
 *
 * This can be useful in situations like object context values, since without memoization an object
 * context would trigger re-renders of all consumers on every update.
 *
 * Note that the keys of the object (and their order) must remain the same for the lifecycle of the
 * component for the hook to work correctly.
 *
 * @param object Object to memoize.
 *
 * @return Memoized object.
 */
const useObjectMemo = object => useMemo(() => object, Object.values(object));
/* harmony default export */ const use_object_memo = ((/* unused pure expression or super */ null && (useObjectMemo)));
;// CONCATENATED MODULE: ../react-hooks/index.ts





;// CONCATENATED MODULE: ./hooks/use-toggle-body-class-by-presence.ts

const activeInstancesByType = new WeakMap();

/**
 * React hook to add a CSS class to the page body element as long as any instance of the given
 * component type is rendered to the page.
 *
 * @param className Class name to add to body element
 * @param Component React component definition
 */
function useToggleBodyClassByPresence(className, Component) {
  /**
   * Increments the number of active instances for the current component by the given amount, adding
   * or removing the body class for the first and last instance respectively.
   */
  function incrementActiveInstances(amount) {
    const activeInstances = activeInstancesByType.get(Component) || 0;
    const nextActiveInstances = activeInstances + amount;
    if (!activeInstances && nextActiveInstances) {
      document.body.classList.add(className);
    } else if (activeInstances && !nextActiveInstances) {
      document.body.classList.remove(className);
    }
    activeInstancesByType.set(Component, nextActiveInstances);
  }
  (0,external_react_namespaceObject.useEffect)(() => {
    incrementActiveInstances(1);
    return () => incrementActiveInstances(-1);
  }, []);
}
/* harmony default export */ const use_toggle_body_class_by_presence = (useToggleBodyClassByPresence);
;// CONCATENATED MODULE: external "focus-trap"
var external_focus_trap_x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var external_focus_trap_y = x => () => x
const external_focus_trap_namespaceObject = external_focus_trap_x({ ["createFocusTrap"]: () => __WEBPACK_EXTERNAL_MODULE_focus_trap_4348fbe4__.createFocusTrap });
;// CONCATENATED MODULE: ./hooks/use-focus-trap.ts


/**
 * React hook which activates a focus trap on the given container ref while the component is
 * mounted, with any options for the underlying focus trap instance. The hook does not detect
 * changes to the options argument, thus new option values are not reflected and conversely
 * memoization is not necessary. Returns ref with trap instance assigned as current after mount.
 */
function useFocusTrap(containerRef, options) {
  const [trap, setTrap] = (0,external_react_namespaceObject.useState)(null);
  (0,external_react_namespaceObject.useEffect)(() => {
    let focusTrap;
    if (containerRef.current) {
      focusTrap = (0,external_focus_trap_namespaceObject.createFocusTrap)(containerRef.current, options);
      focusTrap.activate();
      setTrap(focusTrap);
    }
    return () => {
      focusTrap?.deactivate();
    };
  }, []);
  return trap;
}
/* harmony default export */ const use_focus_trap = (useFocusTrap);
;// CONCATENATED MODULE: ./full-screen.tsx









function useInertSiblingElements(containerRef) {
  (0,external_react_namespaceObject.useEffect)(() => {
    const container = containerRef.current;
    const originalElementAttributeValues = [];
    if (container && container.parentNode) {
      for (const child of container.parentNode.children) {
        if (child !== container) {
          originalElementAttributeValues.push([child, child.getAttribute('aria-hidden')]);
          child.setAttribute('aria-hidden', 'true');
        }
      }
    }
    return () => originalElementAttributeValues.forEach(_ref => {
      let [child, ariaHidden] = _ref;
      return ariaHidden === null ? child.removeAttribute('aria-hidden') : child.setAttribute('aria-hidden', ariaHidden);
    });
  });
}
function FullScreen(_ref2, ref) {
  let {
    onRequestClose = () => {},
    label,
    hideCloseButton = false,
    bgColor = 'white',
    labelledBy,
    describedBy,
    children
  } = _ref2;
  const {
    t
  } = use_i18n();
  const ifStillMounted = use_if_still_mounted();
  const containerRef = (0,external_react_namespaceObject.useRef)(null);
  const onFocusTrapDeactivate = use_immutable_callback(ifStillMounted(onRequestClose));
  const focusTrap = use_focus_trap(containerRef, {
    clickOutsideDeactivates: true,
    onDeactivate: onFocusTrapDeactivate
  });
  (0,external_react_namespaceObject.useImperativeHandle)(ref, () => ({
    focusTrap
  }), [focusTrap]);
  use_toggle_body_class_by_presence('has-full-screen-overlay', FullScreen);
  useInertSiblingElements(containerRef);
  return /*#__PURE__*/(0,external_react_dom_namespaceObject.createPortal)( /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
    ref: containerRef,
    role: "dialog",
    "aria-label": label,
    "aria-labelledby": labelledBy,
    "aria-describedby": describedBy,
    className: `full-screen bg-${bgColor}`,
    children: [children, !hideCloseButton && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("button", {
      type: "button",
      "aria-label": t('account.navigation.close'),
      onClick: onRequestClose,
      className: "full-screen__close-button usa-button padding-2 margin-2",
      children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("img", {
        alt: "",
        src: getAssetPath('close-white-alt.svg'),
        className: "full-screen__close-icon"
      })
    })]
  }), document.body);
}
/* harmony default export */ const full_screen = (/*#__PURE__*/(0,external_react_namespaceObject.forwardRef)(FullScreen));
;// CONCATENATED MODULE: ./icon-list/icon-list.tsx

function IconList(_ref) {
  let {
    children
  } = _ref;
  const classes = 'usa-icon-list';
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("ul", {
    className: classes,
    children: children
  });
}
/* harmony default export */ const icon_list = (IconList);
;// CONCATENATED MODULE: ./icon-list/icon-list-content.tsx

function IconListContent(_ref) {
  let {
    children
  } = _ref;
  const classes = 'usa-icon-list__content';
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    className: classes,
    children: children
  });
}
/* harmony default export */ const icon_list_content = (IconListContent);
;// CONCATENATED MODULE: ./icon-list/icon-list-icon.tsx

function IconListIcon(_ref) {
  let {
    children,
    className
  } = _ref;
  const classes = ['usa-icon-list__icon', 'text-primary-dark', className].filter(Boolean).join(' ');
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    className: classes,
    children: children
  });
}
/* harmony default export */ const icon_list_icon = (IconListIcon);
;// CONCATENATED MODULE: ./icon-list/icon-list-item.tsx



function IconListItem(_ref) {
  let {
    children,
    icon,
    title
  } = _ref;
  const classes = 'usa-icon-list__item';
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("li", {
    className: classes,
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(icon_list_icon, {
      children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(icon_0, {
        icon: icon
      })
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(icon_list_content, {
      children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(icon_list_title, {
        children: title
      }), children]
    })]
  });
}
/* harmony default export */ const icon_list_item = (IconListItem);
;// CONCATENATED MODULE: ./icon-list/icon-list-title.tsx

function IconListTitle(_ref) {
  let {
    children,
    className
  } = _ref;
  const classes = ['usa-icon-list__title', 'font-sans-md', 'padding-top-0', className].filter(Boolean).join(' ');
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("h3", {
    className: classes,
    children: children
  });
}
/* harmony default export */ const icon_list_title = (IconListTitle);
;// CONCATENATED MODULE: ./page-footer.tsx

function PageFooter(_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    className: "margin-top-4 padding-top-2 border-top border-primary-light",
    children: children
  });
}
/* harmony default export */ const page_footer = (PageFooter);
;// CONCATENATED MODULE: ./page-heading.tsx


function PageHeading(_ref, ref) {
  let {
    children,
    className,
    ...props
  } = _ref;
  const classes = ['page-heading', className].filter(Boolean).join(' ');
  return (
    /*#__PURE__*/
    // Disable reason: Intended as pass-through to heading HTML element.
    // eslint-disable-next-line react/jsx-props-no-spreading
    (0,jsx_runtime_namespaceObject.jsx)("h1", {
      ref: ref,
      ...props,
      className: classes,
      children: children
    })
  );
}
/* harmony default export */ const page_heading = (/*#__PURE__*/(0,external_react_namespaceObject.forwardRef)(PageHeading));
;// CONCATENATED MODULE: ./process-list/process-list.tsx

function ProcessList(_ref) {
  let {
    children,
    className
  } = _ref;
  const classes = ['usa-process-list', className].filter(Boolean).join(' ');
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("ol", {
    className: classes,
    children: children
  });
}
/* harmony default export */ const process_list = (ProcessList);
;// CONCATENATED MODULE: ./process-list/process-list-heading.tsx

function ProcessListHeading(_ref) {
  let {
    children,
    unstyled
  } = _ref;
  const headingClass = unstyled === true ? undefined : 'usa-process-list__heading';
  const classes = [headingClass].filter(Boolean).join(' ');
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("p", {
    className: classes,
    children: children
  });
}
/* harmony default export */ const process_list_heading = (ProcessListHeading);
;// CONCATENATED MODULE: ./process-list/process-list-item.tsx



function ProcessListItem(_ref) {
  let {
    children,
    heading,
    headingUnstyled
  } = _ref;
  const classes = 'usa-process-list__item';
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("li", {
    className: classes,
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(process_list_heading, {
      unstyled: headingUnstyled,
      children: heading
    }), children]
  });
}
/* harmony default export */ const process_list_item = (ProcessListItem);
;// CONCATENATED MODULE: ./scroll-into-view.tsx


/**
 * Scrolls content into the user's viewport when mounted.
 */
function ScrollIntoView(_ref) {
  let {
    children
  } = _ref;
  const ref = (0,external_react_namespaceObject.useRef)(null);
  (0,external_react_namespaceObject.useEffect)(() => ref.current?.scrollIntoView(), []);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    ref: ref,
    children: children
  });
}
/* harmony default export */ const scroll_into_view = (ScrollIntoView);
;// CONCATENATED MODULE: ./select-input.tsx





function SelectInput(_ref, ref) {
  let {
    label,
    hint,
    id,
    className,
    children,
    ...inputProps
  } = _ref;
  const instanceId = use_instance_id();
  const inputId = id ?? `select-input-${instanceId}`;
  const hintId = id ?? `select-input-hint-${instanceId}`;
  const classes = ['usa-select', className].filter(Boolean).join(' ');
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("label", {
      className: "usa-label",
      htmlFor: inputId,
      children: label
    }), hint && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
      id: hintId,
      className: "usa-hint",
      children: hint
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("select", {
      ref: ref,
      className: classes,
      id: inputId,
      "aria-describedby": hint && hintId,
      ...inputProps,
      children: children
    })]
  });
}
/* harmony default export */ const select_input = (/*#__PURE__*/(0,external_react_namespaceObject.forwardRef)(SelectInput));
;// CONCATENATED MODULE: ./spinner-dots.jsx


/**
 * @typedef SpinnerDotsProps
 *
 * @prop {boolean=} isCentered Whether to absolutely-position the element at its container's center.
 * Defaults to false.
 * @prop {string=} className Optional class name.
 */

/**
 * @param {SpinnerDotsProps} props
 */
function SpinnerDots(_ref) {
  let {
    isCentered,
    className
  } = _ref;
  const classes = ['spinner-dots', isCentered && 'spinner-dots--centered', className].filter(Boolean).join(' ');
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("span", {
    className: classes,
    "aria-hidden": true,
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("span", {
      className: "spinner-dots__dot"
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("span", {
      className: "spinner-dots__dot"
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("span", {
      className: "spinner-dots__dot"
    })]
  });
}
/* harmony default export */ const spinner_dots = (SpinnerDots);
;// CONCATENATED MODULE: ./status-page.tsx






/**
 * Asset paths for combination of status, icon.
 */
const STATUS_ICONS = {
  info: {
    question: getAssetPath('status/info-question.svg')
  },
  warning: {
    default: getAssetPath('status/warning.svg')
  },
  error: {
    default: getAssetPath('status/error.svg'),
    lock: getAssetPath('status/error-lock.svg')
  }
};

/**
 * Text to be used as text alternative for icon.
 */
const STATUS_ALT = {
  error: (0,identity_i18n_namespaceObject.t)('image_description.error'),
  question: (0,identity_i18n_namespaceObject.t)('image_description.info_question'),
  warning: (0,identity_i18n_namespaceObject.t)('image_description.warning'),
  lock: (0,identity_i18n_namespaceObject.t)('image_description.error_lock')
};
function StatusPage(_ref) {
  let {
    status,
    icon,
    header,
    children,
    actionButtons = [],
    troubleshootingOptions
  } = _ref;
  const src = STATUS_ICONS[status][icon || 'default'];
  const alt = STATUS_ALT[icon || status];
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("img", {
      src: src,
      alt: alt,
      width: 88,
      height: 88,
      className: "display-block margin-bottom-4 alert-icon"
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(page_heading, {
      children: header
    }), children, actionButtons.length > 0 && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
      className: "margin-top-5",
      children: actionButtons.map((actionButton, index) => /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
        className: "margin-top-2",
        children: actionButton
      }, index))
    }), troubleshootingOptions && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
      className: "margin-top-5",
      children: troubleshootingOptions
    })]
  });
}
/* harmony default export */ const status_page = (StatusPage);
;// CONCATENATED MODULE: ./tag.tsx

function Tag(_ref) {
  let {
    children,
    isInformative,
    isBig,
    className,
    ...props
  } = _ref;
  const classes = ['usa-tag', isInformative && 'usa-tag--informative', isBig && 'usa-tag--big', className].filter(Boolean).join(' ');
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("span", {
    ...props,
    className: classes,
    children: children
  });
}
/* harmony default export */ const tag = (Tag);
;// CONCATENATED MODULE: ./text-input.tsx





function TextInput(_ref, ref) {
  let {
    label,
    hint,
    id,
    className,
    ...inputProps
  } = _ref;
  const instanceId = use_instance_id();
  const inputId = id ?? `text-input-${instanceId}`;
  const hintId = id ?? `text-input-hint-${instanceId}`;
  const classes = ['usa-input', className].filter(Boolean).join(' ');
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("label", {
      className: "usa-label",
      htmlFor: inputId,
      children: label
    }), hint && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
      id: hintId,
      className: "usa-hint",
      children: hint
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("input", {
      ref: ref,
      className: classes,
      id: inputId,
      "aria-describedby": hint && hintId,
      ...inputProps
    })]
  });
}
/* harmony default export */ const text_input = (/*#__PURE__*/(0,external_react_namespaceObject.forwardRef)(TextInput));
;// CONCATENATED MODULE: ./troubleshooting-options.tsx




function TroubleshootingOptions(_ref) {
  let {
    headingTag = 'h2',
    heading,
    options
  } = _ref;
  const {
    t
  } = use_i18n();
  if (!options.length) {
    return null;
  }
  const HeadingTag = headingTag;
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("section", {
    className: "troubleshooting-options",
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(HeadingTag, {
      className: "troubleshooting-options__heading",
      children: heading ?? t('components.troubleshooting_options.default_heading')
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("ul", {
      className: "troubleshooting-options__options",
      children: options.map((_ref2, index) => {
        let {
          url,
          text,
          ...extraProps
        } = _ref2;
        return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(block_link, {
            ...extraProps,
            href: url,
            children: text
          })
        }, `tso-${index}`);
      })
    })]
  });
}
/* harmony default export */ const troubleshooting_options = (TroubleshootingOptions);
;// CONCATENATED MODULE: ./index.ts























var __webpack_exports__Alert = __webpack_exports__.bZ;
var __webpack_exports__BlockLink = __webpack_exports__.yG;
var __webpack_exports__Button = __webpack_exports__.zx;
var __webpack_exports__FullScreen = __webpack_exports__.IT;
var __webpack_exports__Icon = __webpack_exports__.JO;
var __webpack_exports__IconList = __webpack_exports__.Zd;
var __webpack_exports__IconListContent = __webpack_exports__.$Z;
var __webpack_exports__IconListIcon = __webpack_exports__.Tw;
var __webpack_exports__IconListItem = __webpack_exports__.Mp;
var __webpack_exports__IconListTitle = __webpack_exports__.$f;
var __webpack_exports__Link = __webpack_exports__.rU;
var __webpack_exports__PageFooter = __webpack_exports__.WA;
var __webpack_exports__PageHeading = __webpack_exports__.CD;
var __webpack_exports__ProcessList = __webpack_exports__.cQ;
var __webpack_exports__ProcessListHeading = __webpack_exports__.z8;
var __webpack_exports__ProcessListItem = __webpack_exports__.qE;
var __webpack_exports__ScrollIntoView = __webpack_exports__.R3;
var __webpack_exports__SelectInput = __webpack_exports__.lq;
var __webpack_exports__SpinnerDots = __webpack_exports__.mZ;
var __webpack_exports__StatusPage = __webpack_exports__.oj;
var __webpack_exports__Tag = __webpack_exports__.Vp;
var __webpack_exports__TextInput = __webpack_exports__.oi;
var __webpack_exports__TroubleshootingOptions = __webpack_exports__.HD;
export { __webpack_exports__Alert as Alert, __webpack_exports__BlockLink as BlockLink, __webpack_exports__Button as Button, __webpack_exports__FullScreen as FullScreen, __webpack_exports__Icon as Icon, __webpack_exports__IconList as IconList, __webpack_exports__IconListContent as IconListContent, __webpack_exports__IconListIcon as IconListIcon, __webpack_exports__IconListItem as IconListItem, __webpack_exports__IconListTitle as IconListTitle, __webpack_exports__Link as Link, __webpack_exports__PageFooter as PageFooter, __webpack_exports__PageHeading as PageHeading, __webpack_exports__ProcessList as ProcessList, __webpack_exports__ProcessListHeading as ProcessListHeading, __webpack_exports__ProcessListItem as ProcessListItem, __webpack_exports__ScrollIntoView as ScrollIntoView, __webpack_exports__SelectInput as SelectInput, __webpack_exports__SpinnerDots as SpinnerDots, __webpack_exports__StatusPage as StatusPage, __webpack_exports__Tag as Tag, __webpack_exports__TextInput as TextInput, __webpack_exports__TroubleshootingOptions as TroubleshootingOptions };
